import { useMemo, useContext } from 'react';
import type { AnnotationId, AnnotationMarkStates } from '@atlaskit/adf-schema/annotation';
import { InlineCommentsStateContext } from '../context';

type Props = {
	annotationIds: AnnotationId[];
	filter: {
		state: AnnotationMarkStates;
	};
};

export const useInlineCommentsFilter = ({
	annotationIds,
	filter: { state: stateFilter },
}: Props): string[] => {
	const states = useContext(InlineCommentsStateContext);
	return useMemo(() => {
		return annotationIds.reduce((acc, id) => {
			if (states && states[id] === stateFilter) {
				return [...acc, id];
			}

			return acc;
		}, [] as string[]);
	}, [annotationIds, states, stateFilter]);
};
